export default {
  ADD_PLACEHOLDER (state, placeholder) {
    state.placeholders.unshift(placeholder)
  },
  SET_PLACEHOLDER (state, placeholders) {
    state.placeholders = placeholders
  },
  UPDATE_PLACEHOLDER (state, placeholder) {
    const placeholderKey = state.placeholders.findIndex((p) => p.key === placeholder.key)
    Object.assign(state.placeholders[placeholderKey], placeholder)
  },
  REMOVE_PLACEHOLDER (state, key) {
    const placeholderKey = state.placeholders.findIndex((p) => p.key === key)
    state.placeholders.splice(placeholderKey, 1)
  }
}
  